import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import App from "./app";
import { createBrowserHistory } from "history";
import { applyMiddleware, createStore } from "redux";
import rootReducer from "../../services/reducer";
import thunk from "redux-thunk";

const history = createBrowserHistory();
const initialState = window.__PRELOADED_STATE__;

// console.log(initialState, "INITIAL STATE");

const store = createStore(
	rootReducer,
	initialState,
	applyMiddleware(thunk)
);

export default function Client() {
	return <HelmetProvider>
		<Provider store={store} >
			<BrowserRouter history={history}>
				<CookiesProvider>
					<App />
				</CookiesProvider>
			</BrowserRouter>
		</Provider>
	</HelmetProvider>
}
